<template>
  <div>
    <div class="col-8">
      <div class="row">
        <div v-if="tipo == 'Solicitante'" 
             class="col-4">
          <div role="group"
               class="form-group">
            <label for="input-live"
                   class="label">CPF {{ tipo }}:</label>
            <div><span class="font-visualizacao">{{ form.cpf ? form.cpf : 'Não informado' }}</span></div>
          </div>
        </div>
        <div class="col-6">
          <div role="group"
               class="form-group">
            <label for="input-live"
                   class="label">Nome {{ tipo }}:</label>
            <div><span class="font-visualizacao">{{ form.nome ? form.nome : 'Não informado' }}</span></div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-8">
      <div class="row">
        <div class="col-4">
          <div role="group"
               class="form-group">
            <label for="input-live"
                   class="label">Telefone:</label>
            <div><span class="font-visualizacao">{{ form.telefone ? form.telefone : 'Não informado' }}</span></div>
          </div>
        </div>
        <div v-if="tipo == 'Solicitante'" 
             class="col-4">
          <div role="group"
               class="form-group">
            <label for="input-live"
                   class="label">Celular:</label>
            <div><span class="font-visualizacao">{{ form.celular ? form.celular : 'Não informado' }}</span></div>
          </div>
        </div>
        <div class="col-4">
          <div role="group"
               class="form-group">
            <label for="input-live"
                   class="label">Email:</label>
            <div><span class="font-visualizacao">{{ form.email ? form.email : 'Não informado' }}</span></div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <!--INICIO COMPONENTE CARLOS-->

      <div class="endereco_header">
        Endereço
      </div>
      <form name="cadastroEndereco"
            novalidate>
        <slot name="radios" />

        <div class="row align-items-end">
          <div class="col-sm-4 col-lg-3 mt-1">
            <div class="form-group">
              <label class="label"
                     for="cep">CEP</label>
              <div><span class="font-visualizacao">{{ form.endereco.cep ? form.endereco.cep : 'Não informado' }}</span></div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label class="label"
                     for="endereco">Endereço</label>
              <div><span class="font-visualizacao">{{ form.endereco.logradouro ? form.endereco.logradouro : 'Não informado' }}</span></div>
            </div>
          </div>

          <div class="col-sm-3 col-lg-2">
            <div class="form-group">
              <label class="label"
                     for="numero">Número</label>
              <div><span class="font-visualizacao">{{ form.endereco.numero ? form.endereco.numero : 'Não informado' }}</span></div>
            </div>
          </div>

          <div class="col-sm-4 col-lg-3 col-xl-2">
            <div class="form-group">
              <label class="label"
                     for="complemento">Complemento</label>
              <div><span class="font-visualizacao">{{ form.endereco.complemento ? form.endereco.complemento : 'Não informado' }}</span></div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-4">
            <div class="form-group">
              <label class="label"
                     for="bairro">Bairro</label>
              <div><span class="font-visualizacao">{{ form.endereco.bairro ? form.endereco.bairro : 'Não informado' }}</span></div>
            </div>
          </div>

          <div class="col-sm-4 col-md-4">
            <div class="form-group">
              <label class="label"
                     for="cidade">Cidade</label>
              <div><span class="font-visualizacao">{{ form.endereco.cidade ? form.endereco.cidade : 'Não informado' }}</span></div>
            </div>
          </div>

          <div class="col-sm-3 col-md-2">
            <div class="form-group">
              <label class="label"
                     for="estado">UF</label>
              <div><span class="font-visualizacao">{{ form.endereco.uf ? form.endereco.uf : 'Não informado' }}</span></div>
            </div>
          </div>
        </div>
      </form>

      <!-- FIM COMPONENTE CARLOS -->
    </div>
  </div>
</template>

<script>
  export default {
    name: "BoxVisualizacao",
    props: ["form", "tipo"]
  }
</script>

<style lang="scss">
  @import "../../../scss/_utilities/_exports";

  .endereco_header{
    background-color: $color-gray-light;
    padding: 10px 0;
    padding-left: 10px;
    font-size: pxToRem(16);
    font-weight: 500;
    padding: pxToRem(8);
  }
  .font-visualizacao{
    font-size: pxToRem(14);
  }
</style>
